import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import queryString from 'query-string'
import {
  fetchSelectFindingRule,
  fetchScopedFindingRuleToDelete,
  deleteFindingRule,
  fetchFindingField,
} from '../../_redux/_actions/selectFindingRuleAction'
import { persistSelectedFindingRule } from '../../_redux/_actions/detailsPersistActions'
import { history } from '../../_redux/_store/history'
import FooterPagination from '../_footerpagination/FooterPagination'
import EditFindingRule from '../_selectFindingRule/EditFindingRule.jsx'
import { EditFindingRuleSuccess } from '../_selectFindingRule/EditFindingRule.jsx'
import { withStyles, makeStyles } from '@material-ui/core/styles'
import { Paper, Box, TableHead } from '@material-ui/core'
import Tooltip from '@material-ui/core/Tooltip'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableRow from '@material-ui/core/TableRow'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import SearchRoundedIcon from '@material-ui/icons/SearchRounded'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import InputAdornment from '@material-ui/core/InputAdornment'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import { DialogContent} from '@material-ui/core/'
import CancelIcon from '@material-ui/icons/Cancel'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'
import {Tab, Tabs} from '@material-ui/core'
import HelpBlockImg from '../../_assets/_images/helpBlock.png'
import ErrorHandler from '../updateHandlers/ErrorHandler'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import SkeletonTableList from '../skeleton/SkeletonTableList.jsx'
import { BreadcrumbDispatch } from '../../App'

const StyledTableCell = withStyles((theme) => ({
  head: {
    color: 'white',
  },
  body: {
    fontSize: 14,
  },
}))(TableCell)

const useStyles = makeStyles((theme) => ({
  Button: {
    width: '120px',
    marginRight: '20px',
    borderRadius: '3px !important',
    '&:hover': {
      background: '#52A1C2',
    },
  },
  helpIcon: {
    marginBottom: '-5px',
    marginLeft: '5px',
    width: '20px',
  },
  HelpBlockImg: {
    display: 'block',
    margin: 'auto',
    width: '100%',
    marginTop: '80px',
  },
  accordionButton: {
    '&:hover': {
      backgroundColor: 'white',
    },
    containerPaper: {
      height: '70%',
      padding: '30px',
      opacity: '1',
    },
    deleteFindingRuleTable: {
      marginTop: '2em',
    },
  },
  searchField: {
    marginTop: '-0.75em',
    marginRight: '20px',
  },
  containerPaper: {
    padding: '50px',
    height: '100%',
  },
  Pagination: {
    marginBottom: '30px',
    marginRight: '30px',
    marginTop: '30px',
  },
  deleteRuleTable: {
    maxHeight: 150,
    marginBottom: '30px',
  },
  paragraph: {
    marginTop: '-20px',
    marginBottom: '30px',
  },
  findingFieldSelect: {
    width: '120px',
    height: '50px',
    marginLeft: '10px',
  },
  tabsRoot:{
    marginBottom:"10px",
    '& .MuiTab-root': {
        fontFamily: 'NotoSansRegular, Helvetica, sans serif',
        fontSize: '14px',
        fontStyle:'normal',
        fontWeight: '600',
        lineWeight: '28px',
        letterSpacing: '0.0025em',
        textAlign: 'left',
        color:'#262523',
        [theme.breakpoints.down('768')]:{
            fontSize: '12px'
      }
    }
  },
}))

const Accordion = withStyles({
  root: {
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
  },
  expanded: {},
})(MuiAccordion)

const AccordionSummary = withStyles({
  root: {
    marginBottom: -1,
  },
})(MuiAccordionSummary)

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails)

export default function SelectFindingRule() {
  const classes = useStyles()
  const [rules, setRules] = useState('')
  const [findingField, setFindingField] = useState('')
  const [findingFieldAdded, setFindingFieldAdded] = useState('none')
  const [ruleMatch, setRuleMatch] = useState(true)
  const [currentPage, setcurrentPage] = useState(1)
  const [page, setPage] = useState(1)
  const [rulesPerPage] = useState(5)
  const [deleteFindingOpen, setdeleteFindingOpen] = useState(false)
  const [deleteScopedFinding, setDeleteScopedFinding] = useState('')
  const [findingRuleIdToDelete, setFindingRuleIdToDelete] = useState('')
  const [deleteFindingRuleDialog, setDeleteFindingRuleDialog] = useState(false)
  const [deleteFindingRuleFailure, setDeleteFindingRuleFailure] =
    useState(false)
  const [editFindingRule, setEditFindingRule] = useState(false)
  const [dataToEdit, setDataToEdit] = useState('')
  const [editFindingSuccess, setEditFindingSuccess] = useState(false)
  const [editFindingFailure, setEditFindingFailure] = useState(false)
  const [filteredData, setFilteredData] = useState('')
  const [currentRule, setCurrentRule] = useState('')
  const [expanded, setExpanded] = useState(false)
  const [searchValue, setSearchValue] = useState(false)
  const [tabValue, setTabValue] = useState(0);
  const dispatch = useDispatch()
  const queryValues = queryString.parse(history.location.search)
  const {machine_type, hmi_type} = queryValues

  let activeFindings = [];

  const selectFindingRuleResponse = useSelector(
    (state) => state.selectFindingRule
  )

  useEffect(() => {
    if(!history.location.search)
    {
      history.push('/rules');
      return;
    }
    dispatch(fetchSelectFindingRule(null,machine_type,hmi_type))
    dispatch(fetchFindingField(machine_type,hmi_type))
  }, [])

  useEffect(() => {
    if(editFindingSuccess){
    dispatch(fetchSelectFindingRule(null,machine_type,hmi_type))
  }
  }, [editFindingSuccess])

  useEffect(() => {
    if (selectFindingRuleResponse.selectFindingRule) {
      setFindingField(selectFindingRuleResponse.selectFindingField)
      setFindingFieldAdded(selectFindingRuleResponse.selectFindingField[0] ? selectFindingRuleResponse.selectFindingField[0].id : null)
      setRules(selectFindingRuleResponse.selectFindingRule)
      if (searchValue) {
        searchRule(searchValue)
      } 
      else {
        handleTabChange(null, tabValue)
      }
    }
    if (selectFindingRuleResponse.scopeFinding) {
      setDeleteScopedFinding(
        selectFindingRuleResponse.scopeFinding && selectFindingRuleResponse.scopeFinding[0]?.scopedFindingRules 
      ) 
    }
  }, [selectFindingRuleResponse])

  useEffect(() => {
    const indexOfLastRule = currentPage * rulesPerPage
    const indexOfFirstRule = indexOfLastRule - rulesPerPage
    setCurrentRule(filteredData.slice(indexOfFirstRule, indexOfLastRule))
  }, [filteredData, currentPage])

  useEffect(()=>{
    if (searchValue) {
      searchRule(searchValue)
    } 
  },[tabValue])

  //setting current page
  const paginate = (pageNumber) => {
    setcurrentPage(pageNumber)
  }

  const handleChange = (event, value) => {
    setPage(value)
    paginate(value)
  }

  //Search Find Rule by Name functionality
  const searchRule = (value) => {
    let findingsInProgress = selectFindingRuleResponse?.selectFindingRule?.filter(item => item.finding_finished === false);
    let findingsActive = selectFindingRuleResponse?.selectFindingRule?.filter(item => item.finding_finished === true);
    setSearchValue(value)
    const filteredRules = []
    var isValid
    (tabValue === 0 ? findingsActive : findingsInProgress).map((item) => {
      isValid = 0
      value.split(' ').map((key) => {
        if (
          item.name.toLowerCase().includes(key.toLowerCase()) ||
          item.description.toLowerCase().includes(key.toLowerCase()) || 
          item.id.toString().includes(key.toString())
        ) 
        {
          isValid = isValid + 1
        }
      })
      if (isValid === value.split(' ').length) {
        filteredRules.push(item)
      }
    })
    setFilteredData(
      filteredRules.sort((a, b) => {
        return b.id - a.id
      })
    )
    if (filteredRules.length === 0) {
      setRuleMatch(false)
    } else {
      setRuleMatch(true)
      setcurrentPage(1)
      setPage(1)
    }
  }

  //fetch scope data of the finding rule to delete
  const handleDelete = async (findingRuleId) => {
    setdeleteFindingOpen(true)
    setFindingRuleIdToDelete(findingRuleId)
    await dispatch(fetchScopedFindingRuleToDelete(findingRuleId,machine_type, hmi_type))
  }

  //deleting Finding Rule
  const deleteFindingRuleFunc = () => {
    dispatch(deleteFindingRule(findingRuleIdToDelete, handleDeleteFindingRule, machine_type,hmi_type))
    setdeleteFindingOpen(false)
  }

  const handleDeleteFindingRule = (value) => {
    if (value) {
      setDeleteFindingRuleDialog(true)
      var deletedRule = filteredData.filter(
        (item) => item.id !== findingRuleIdToDelete
      )
      setFilteredData(deletedRule)
      dispatch(fetchSelectFindingRule(null,machine_type,hmi_type))
    } else {
      setDeleteFindingRuleFailure(true)
    }
  }

  //close delete success pop up
  const closeDeleteSuccessPopUp = () => {
    setDeleteFindingRuleDialog(false)
  }

  //Edit finding rule
  const handleEdit = (data) => {
    setEditFindingRule(true)
    setDataToEdit(data)
  }

  //close the edit pop up
  const handleClose = () => {
    setEditFindingRule(false)
  }

  //controlled accordion
  const handleAccordionChange = (row) => (event, isExpanded) => {
    setExpanded(isExpanded ? row : false)
  }

  //route to select scope page
  const goToSelectScope = (row) => {
    dispatch(persistSelectedFindingRule(row))
    history.push(`/rules/select_finding_rule/select_scope?machine_type=${machine_type}&hmi_type=${hmi_type}&findingRuleId=${row.id}`)
  }

  const handleTabChange = async(event, newValue) => {
    let findings = [];
    if(newValue === 0){
      findings = selectFindingRuleResponse?.selectFindingRule?.filter(item => item.finding_finished === true);
    }
    else{
      findings = selectFindingRuleResponse?.selectFindingRule?.filter(item => item.finding_finished === false);
    }
    setTabValue(newValue);
    let validPageNumber = Math.round(findings.length/rulesPerPage)
    setcurrentPage(page <= validPageNumber ? page : 1)
    setPage(page <= validPageNumber ? page : 1)
    setFilteredData(
      findings.sort((a, b) => {
        return b.id - a.id
      })
    )
  };  

  function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`tabpanel-${index}`}
        aria-labelledby={`tab-${index}`}
        {...other}
      >
        {value === index && (
          <>  {children} </>
        )}
      </div>
    );
  }

  function a11yProps(index) {
    return {
        id: `tab-${index}`,
        'aria-controls': `tabpanel-${index}`,
    };
  }

  return (
    <Grid container direction='row' spacing={4}>
      <BreadcrumbDispatch />
      <Grid item md={9}>
        <Paper className={classes.containerPaper}>
          <Grid
            container
            direction='row'
            justifyContent='space-between'
            alignItems='center'
          >
            <Grid item style={{ marginBottom: '30px' }}>
              <Grid container alignItems='flex-end'>
                <Grid item>
                  <Typography
                    variant='h4'
                    style={{ color: '#52A1C2', fontSize: '1.5rem' }}
                  >
                    Select Finding Rule
                  </Typography>
                </Grid>
                <Grid item>
                  <Tooltip title='question'>
                    <HelpOutlineIcon className={classes.helpIcon} />
                  </Tooltip>
                </Grid>
              </Grid>
            </Grid>
            <Grid item style={{ marginBottom: '30px' }}>
              <Grid container alignItems='flex-end'>
                <Grid item className={classes.searchField}>
                  <TextField
                    error={!ruleMatch}
                    helperText={!ruleMatch ? 'No Match Found' : ''}
                    id='findingrule-search'
                    label='Search Finding Rule'
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position='end'>
                          <SearchRoundedIcon />
                        </InputAdornment>
                      ),
                    }}
                    onChange={(e) => searchRule(e.target.value)}
                  />
                </Grid>
                <Grid item>
                  <Button id="createFindingButton" variant='outlined' onClick={() =>  history.push(`/rules/select_finding_rule/create_finding_rule?machine_type=${machine_type}&hmi_type=${hmi_type}`)}>
                    {' '}
                    + CREATE NEW
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Tabs
              classes={{
                  root:classes.tabsRoot
              }}
              value={tabValue}
              onChange={handleTabChange}
              aria-label="finding rules tab"
              TabIndicatorProps={{style: {background:'#AFC3CD'}}}
            >
              <Tab label={'Active Findings'} {...a11yProps(0)} />
              <Tab label={'Findings in Progress'} {...a11yProps(1)} />
            </Tabs>
            <TabPanel value={tabValue} index={tabValue}>
              <TableContainer id="finding_rule_table">
                <Table aria-label='custom pagination table'>
                  <TableHead>
                    <TableRow
                      fullwidth='true'
                      style={{ backgroundColor: 'grey' }}
                    >
                      <StyledTableCell style={{ width: '5%' }}>
                        <Typography style={{ color: 'white' }}>S.No</Typography>
                      </StyledTableCell>
                      <StyledTableCell align='left' style={{ width: '50%' }}>
                        <Typography style={{ color: 'white' }}>
                          Finding Rule Name
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell align='left' style={{ width: '45%' }}>
                        <Typography style={{ color: 'white' }}>
                          Description
                        </Typography>
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody fullwidth='true' id="finding_Actions">
                  {selectFindingRuleResponse.loading && <SkeletonTableList count={3} />}
                    {!selectFindingRuleResponse.loading && currentRule
                      ? currentRule.map((row) => (
                          <TableRow style={{ height: 10 }} key={row.id}>
                            <TableCell component='th' scope='row'>
                              {row.id}
                            </TableCell>
                            <TableCell align='left'>
                              <Accordion
                                square
                                elevation={0}
                                expanded={expanded === row.id}
                                onChange={handleAccordionChange(row.id)}
                              >
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls='panel1a-content'
                                  id='panel1'
                                >
                                  {row.name}
                                </AccordionSummary>
                                <AccordionDetails>
                                  <Grid
                                    container
                                    direction='row'
                                    style={{ marginLeft: '0.5em' }}
                                  >
                                    <Grid item>
                                      <Button
                                        id="confirmButton"
                                        style={{ backgroundColor: '#52A1C2' }}
                                        onClick={() => goToSelectScope(row)}
                                      >
                                        Confirm
                                      </Button>
                                    </Grid>
                                    <Grid style={{ marginLeft: '0.5em' }}>
                                      <Button
                                        className={classes.accordionButton}
                                        onClick={() => handleEdit(row)}
                                      >
                                        <EditIcon style={{ fill: 'grey' }} />
                                      </Button>
                                    </Grid>
                                    <Grid item style={{ marginLeft: '0.5em' }}>
                                      <Button
                                        className={classes.accordionButton}
                                        onClick={() => handleDelete(row.id)}
                                      >
                                        <DeleteIcon style={{ fill: 'grey' }} />
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </AccordionDetails>
                              </Accordion>
                            </TableCell>
                            <TableCell align='left'><div style={{whiteSpace: "pre-wrap"}}>{row.description}</div></TableCell>
                          </TableRow>
                        ))
                      :!selectFindingRuleResponse.loading? <TableRow
                      style={{ height: 10 }}
                    >
                      <TableCell colSpan={5}>
                      No data found
                      </TableCell>
                    </TableRow>:null}
                  </TableBody>
                </Table>
                <FooterPagination
                  page={page}
                  handleChange={handleChange}
                  rulesPerPage={rulesPerPage}
                  totalRules={filteredData.length}
                  paginate={paginate}
                />
              </TableContainer>
            </TabPanel>
        </Paper>
      </Grid>
      <Grid item md={3} className='helpBlock'>
        <Paper className={classes.containerPaper}>
          <Box component='div' className='helpBlockTitle'>
            Help
          </Box>
          <br />
          <p>
            Finding Rules define how anomalies are combined to give sensible
            Recommendations
          </p>
          <br />
          <p>Select a Finding rule from the table or create a new one</p>
          <br />
          <p>
            After that you will be guided to proceed to pick a scope where your
            configuration applies and define the triggering operation (Boolean
            expression from anomalies) and Recommendations
          </p>
          <br />
          <Box component='div'>
            <img
              src={HelpBlockImg}
              alt='HelpBlockImg'
              className={`${classes.HelpBlockImg} img-fluid`}
            />
          </Box>
        </Paper>
      </Grid>

      {/* Delete Finding Rule */}
      <Dialog
        open={deleteFindingOpen}
        onClose={() => setdeleteFindingOpen(false)}
        maxWidth={'md'}
        PaperProps={{ style: deleteScopedFinding && deleteScopedFinding?.length > 0 ? { width: '60em', height: '30em' } : { width: '38  em', height: '20em' } }}
      >
        <DialogContent style={{ overflow: 'hidden' }}>
          <Grid item container direction='column' justifyContent='center'>
            <Grid
              container
              direction='row'
              justifyContent='space-between'
              style={{ marginBottom: '3em', marginTop: '2em' }}
            >
              <Grid item>
                <Typography style={{ color: 'Red', fontWeight: 1000 }}>
                  Attention
                </Typography>
              </Grid>
              <Grid item>
                <Button onClick={() => setdeleteFindingOpen(false)}>
                  <CancelIcon style={{ color: '#666666' }} />
                </Button>
              </Grid>
            </Grid>
            {deleteScopedFinding && deleteScopedFinding.length > 0?
            <Grid item className={classes.paragraph}>
              <p>
                Deleting this finding rule will also result in removing
                following Scoped Finding Rules
              </p>
            </Grid>
            : 
            <Grid item className={classes.paragraph}>
            <p>Are you sure you want to delete this finding rule?</p>
            </Grid>
            }
            {deleteScopedFinding && deleteScopedFinding.length > 0 ? <Grid item>
              <TableContainer
                className={classes.deleteRuleTable}
              >
                <Table className={classes.deleteFindingRuleTable}>
                  <TableHead>
                    <TableRow style={{ backgroundColor: 'grey' }}>
                      <StyledTableCell>
                        <Typography style={{ color: 'white' }}>
                          Scope
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell align='left'>
                        <Typography style={{ color: 'white' }}>
                          Note Text
                        </Typography>
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {!deleteScopedFinding && <SkeletonTableList count={2}/>}
                    {deleteScopedFinding
                      ? deleteScopedFinding.map((row) => (
                          <TableRow
                            style={{ height: 10 }}
                            key={`delete${row.scope}`}
                          >
                            <TableCell component='th' scope='row'>
                              {row.scope}
                            </TableCell>
                            <TableCell component='th' scope='row'>
                              {row.note_text}
                            </TableCell>
                          </TableRow>
                        ))
                      : null}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            : null
            }
            <Grid container direction='row' style={{ marginTop: '10px' }}>
              <Grid item>
                <Button
                  variant='outlined'
                  className={classes.Button}
                  onClick={() => deleteFindingRuleFunc()}
                >
                  CONFIRM
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant='outlined'
                  onClick={() => setdeleteFindingOpen(false)}
                  className={`${classes.Button} btn-white`}
                >
                  CANCEL
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      {/* delete finding rule error */}
      {deleteFindingRuleFailure && (
        <ErrorHandler message={selectFindingRuleResponse.error} />
      )}

      {/* Pop up to show if the delete finding rule  has been successful */}

      <Dialog
        open={deleteFindingRuleDialog}
        onClose={() => setDeleteFindingRuleDialog(false)}
        maxWidth={'md'}
        PaperProps={{ style: { width: '30em', height: '20em' } }}
      >
        <DialogContent style={{ padding: '30px' }}>
          <Grid
            item
            container
            direction='column'
            justifyContent='center'
            alignItems='center'
          >
            <Grid item>
              <CheckCircleOutlineIcon
                style={{ width: '3em', height: '3em', color: '#52A1C2' }}
              />
            </Grid>
            <Grid item style={{ marginTop: '20px', marginBottom: '20px' }}>
              Finding Rule has been deleted successfully
            </Grid>
            <Grid item>
              <Button
                onClick={() => closeDeleteSuccessPopUp()}
                className={classes.Button}
                variant='outlined'
              >
                <Typography>OK</Typography>
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      {/* Rendering Edit Finding Rule Component */}
      {editFindingRule && (
        <EditFindingRule
          open={editFindingRule}
          dataToEdit={dataToEdit}
          onClose={(e) => handleClose()}
          setEditFindingSuccess={setEditFindingSuccess}
          setEditFindingFailure={setEditFindingFailure}
        />
      )}

      {/* Rendering Edit Success dialog */}
      {editFindingSuccess && (
        <EditFindingRuleSuccess
          open={editFindingSuccess}
          setEditFindingSuccess={setEditFindingSuccess}
        />
      )}

      {/* Error when edit finding rule fails */}
      {editFindingFailure && (
        <ErrorHandler message={selectFindingRuleResponse.error} />
      )}
    </Grid>
  )
}
